import { IButton } from '@core/modules/components/button-v2/button.interface';
import { NODA_FORM_ROUTER_LINK } from '@shared/constants/links';
import { ISection } from '@shared/interfaces/section.interface';

export const headerConditions: ISection = {
  title: 'common.best-conditions-v2.subtitle',
  subtitle: 'common.best-conditions-v2.title',
};

export const buttonConditions: IButton = {
  icon: { position: 'right', name: 'arrow_drop_right' },
  text: 'common.best-conditions-v2.additional.btn',
  link: NODA_FORM_ROUTER_LINK,
};

export const itemsConditions: string[] = [
  'common.best-conditions-v2.additional.details.option-1',
  'common.best-conditions-v2.additional.details.option-2',
  'common.best-conditions-v2.additional.details.option-3',
  'common.best-conditions-v2.additional.details.option-4',
];
